var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "heart_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#heart_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.162 4.723a4.041 4.041 0 0 0-2.629.083c-.85.321-1.6.922-2.139 1.734-.54.81-.84 1.788-.856 2.8.003 3.076 2.077 5.599 4.33 7.419A22.193 22.193 0 0 0 12 19.378l.06-.029a22.197 22.197 0 0 0 4.073-2.59c2.252-1.82 4.326-4.343 4.328-7.418a5.207 5.207 0 0 0-.855-2.801 4.49 4.49 0 0 0-2.14-1.734 4.041 4.041 0 0 0-2.628-.083 4.42 4.42 0 0 0-2.223 1.592.768.768 0 0 1-1.23 0 4.42 4.42 0 0 0-2.223-1.592ZM12 20.23l-.307.707-.003-.001-.007-.003-.023-.01a14.764 14.764 0 0 1-.394-.185 23.73 23.73 0 0 1-4.364-2.776C4.54 16.051 2 13.13 2 9.334v-.01a6.753 6.753 0 0 1 1.114-3.641 6.029 6.029 0 0 1 2.877-2.322 5.575 5.575 0 0 1 3.622-.114c.897.276 1.712.771 2.387 1.436a5.868 5.868 0 0 1 2.387-1.436 5.575 5.575 0 0 1 3.622.114 6.029 6.029 0 0 1 2.877 2.322A6.754 6.754 0 0 1 22 9.324v.011c0 3.795-2.54 6.717-4.902 8.625a23.732 23.732 0 0 1-4.758 2.961l-.023.01-.007.004h-.002s-.002.001-.308-.706Zm0 0 .306.707a.768.768 0 0 1-.613 0l.307-.707Z",
    fill: "currentColor"
  }))));
};
export default SvgHeart;